import { render, staticRenderFns } from "./Environment.vue?vue&type=template&id=4f6ec1b1&scoped=true"
import script from "./Environment.vue?vue&type=script&lang=js"
export * from "./Environment.vue?vue&type=script&lang=js"
import style0 from "./Environment.vue?vue&type=style&index=0&id=4f6ec1b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6ec1b1",
  null
  
)

export default component.exports